import React from 'react';

export const useDiploma = () => {
	const [selected, setSelected] = React.useState('');

	const setDiplomaUrl = (url: string) => {
		setSelected(url);
	};

	return {
		selected,
		setDiplomaUrl,
	};
};
